module.exports = __webpack_public_path__ + "img/water_des_4.c68b1ba5.jpg";